import { render, staticRenderFns } from "./IconSvgIco.vue?vue&type=template&id=5b676dc6&scoped=true&"
import script from "./IconSvgIco.vue?vue&type=script&lang=js&"
export * from "./IconSvgIco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b676dc6",
  null
  
)

export default component.exports